// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Videos Page - Main Structure */
.videos-page {
    width: 100%;
    margin: auto;
    padding: 2rem;
    background-color: var(--clr-background);
    color: var(--clr-grey-1);

    /* Border & Box Shadow for Professional Look */
    border: 15px solid var(--clr-primary-5);
    border-radius: var(--radius); 
    box-shadow: var(--shadow-2);
    background: linear-gradient(
        135deg, 
        var(--clr-primary-9) 0%, 
        var(--clr-primary-4) 100%
    );

    /* Subtle Inner Shadow for Depth */
    box-shadow: inset 0px 4px 8px rgba(0, 0, 0, 0.05);
}

/* Header Section */
.videos-header {
    text-align: center;
    margin-bottom: 2rem;
}

.videos-header h1 {
    font-size: 2.5rem;
    font-weight: bold;
    color: var(--clr-grey-1);
    text-transform: uppercase;
    letter-spacing: 1px;

    /* Fancy Text Gradient Effect */
    background: linear-gradient(to right, var(--clr-primary-5), var(--clr-primary-3));
    background-clip: text;
    -webkit-background-clip: text;
    /* -webkit-text-fill-color: transparent; */
}


.videos-header p {
    font-size: 1.2rem;
    color: var(--clr-grey-2);
    /* max-width: 700px; */
    margin: auto;
}

/* ✨ Stylish Divider */
.divider {
    width: 70%;
    margin: 2rem auto;
    border: none;
    height: 4px;
    background: linear-gradient(
        to right,
        transparent,
        var(--clr-primary-5),
        var(--clr-primary-6),
        var(--clr-primary-5),
        transparent
    );
    border-radius: var(--radius);
    opacity: 0.8;
    position: relative;
}

/* Adding subtle glowing effect */
.divider::before,
.divider::after {
    content: "";
    position: absolute;
    width: 12px;
    height: 12px;
    background: var(--clr-primary-5);
    border-radius: 50%;
    top: 50%;
    transform: translateY(-50%);
}

.divider::before {
    left: 0;
    box-shadow: 0 0 8px var(--clr-primary-5);
}

.divider::after {
    right: 0;
    box-shadow: 0 0 8px var(--clr-primary-6);
}

/* Main Video Section */
.main-video-container {
    text-align: center;
    margin-bottom: 3rem;
}

.main-video-container h2 {
    font-size: 1.8rem;
    color: var(--clr-primary-2);
    margin-bottom: 1rem;
}

/* Subtitle Effect */
.video-description {
    font-size: 1.1rem;
    color: var(--clr-grey-2);
    margin-top: 1rem;
    font-style: italic;
}

/* Laptop Frame Styling */
.laptop-frame {
    width: 100%;
    max-width: 800px;
    margin: auto;
    padding: 1.5rem;
    background: var(--clr-white);
    border: 6px solid var(--clr-grey-3);
    border-radius: 20px; 
    box-shadow: var(--shadow-3); 
    display: flex;
    justify-content: center;
    align-items: center;

    /* Shadow Effect */
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
}

/* Video Styling */
video {
    width: 100%;
    border-radius: 10px;
    box-shadow: var(--shadow-2);
    transition: transform 0.3s ease-in-out;
}

/* Hover Effect */
video:hover {
    transform: scale(1.02);
}

/* Sections & Video Cards */
.video-sections {
    width: 100%;
    padding: 3rem 0;
}

/* Section Title */
/* .section-title {
    font-size: 1.8rem;
    font-weight: 600;
    color: var(--clr-grey-1);
    text-align: center;
    margin-bottom: 1.5rem;
    position: relative;
    text-transform: uppercase;
    letter-spacing: 1px;
} */

/* Section Title Underline Effect */
/* .section-title::after {
    content: "";
    display: block;
    width: 60px;
    height: 3px;
    background: var(--clr-grey-4);
    margin: 0.5rem auto;
    border-radius: 5px;
} */

/* Video Thumbnails Grid */
.video-thumbnails {
    display: grid;
    grid-template-columns: repeat(3, minmax(250px, 1fr));
    gap: 60px;
    justify-content: center;
    padding: 1rem;

    /* Spacing on Left & Right */
    margin-left: auto;
    margin-right: auto;
    max-width: 85%; 
}

/* Subtle Background Panel */
.video-thumbnails::before {
    content: "";
    position: absolute;
    inset: 0; 
    background: var(--clr-grey-10);
    z-index: -1;
    border-radius: var(--radius);
}

/* Individual Video Card */
.video-card {
    background: var(--clr-white);
    border-radius: var(--radius);
    box-shadow: var(--shadow-2);
    transition: var(--transition);
    overflow: hidden;
    text-align: center;
    padding: 1rem;
    cursor: pointer;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 320px;

    /*  Professional Dual Border */
    border: 3px solid var(--clr-grey-6);
    background-clip: padding-box, border-box;
    background-origin: padding-box, border-box;
    background-image: linear-gradient(var(--clr-white), var(--clr-white)), 
                      linear-gradient(135deg, var(--clr-primary-5), var(--clr-primary-3));
}

/*  Hover Effect */
.video-card:hover {
    transform: translateY(-5px);
    box-shadow: var(--shadow-3);
    border-color: var(--clr-primary-6);
    background-image: linear-gradient(var(--clr-white), var(--clr-white)), 
                      linear-gradient(135deg, var(--clr-primary-6), var(--clr-primary-4));
}

.video-thumbnail {
    width: 100%;
    height: 150px;
    background: var(--clr-grey-9);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: var(--radius);
    position: relative;
    transition: var(--transition);
    overflow: hidden; 
}

.video-thumbnail img {
    width: 100%;
    height: 100%;
    object-fit: cover; 
    border-radius: var(--radius);
    transition: var(--transition);
}

/* Hover Effect */
.video-card:hover .video-thumbnail img {
    filter: brightness(0.7);
    transform: scale(1.05);
}

/* Play Icon */
.play-icon {
    font-size: 2rem;
    color: var(--clr-primary-6);
    position: absolute;
    transition: var(--transition);
}

/* Hover Effect for Play Icon */
.video-card:hover .play-icon {
    color: var(--clr-primary-3);
    transform: scale(1.1);
}

/* Video Title */
.video-title {
    font-size: 1rem; 
    font-weight: 600;
    color: var(--clr-grey-2);
    margin-top: 0.5rem;
    transition: var(--transition);
    text-align: center;
}

/* Video Title Hover */
.video-card:hover .video-title {
    color: var(--clr-primary-4);
}

/* Responsive Adjustments */
@media (max-width: 1024px) {
    .video-thumbnails {
        grid-template-columns: repeat(2, minmax(200px, 1fr));
    }
}

@media (max-width: 600px) {
    .video-thumbnails {
        grid-template-columns: repeat(1, minmax(200px, 1fr)); 
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Videos/VideosPage.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uCAAuC;IACvC,wBAAwB;;IAExB,8CAA8C;IAC9C,uCAAuC;IACvC,4BAA4B;IAC5B,2BAA2B;IAC3B;;;;KAIC;;IAED,kCAAkC;IAClC,iDAAiD;AACrD;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,wBAAwB;IACxB,yBAAyB;IACzB,mBAAmB;;IAEnB,+BAA+B;IAC/B,iFAAiF;IACjF,qBAAqB;IACrB,6BAA6B;IAC7B,0CAA0C;AAC9C;;;AAGA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,sBAAsB;IACtB,YAAY;AAChB;;AAEA,sBAAsB;AACtB;IACI,UAAU;IACV,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX;;;;;;;KAOC;IACD,4BAA4B;IAC5B,YAAY;IACZ,kBAAkB;AACtB;;AAEA,iCAAiC;AACjC;;IAEI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,OAAO;IACP,wCAAwC;AAC5C;;AAEA;IACI,QAAQ;IACR,wCAAwC;AAC5C;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,yBAAyB;AACzB;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,4BAA4B;IAC5B,mCAAmC;IACnC,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA,kBAAkB;AAClB;IACI,WAAW;IACX,mBAAmB;IACnB,2BAA2B;IAC3B,sCAAsC;AAC1C;;AAEA,iBAAiB;AACjB;IACI,sBAAsB;AAC1B;;AAEA,2BAA2B;AAC3B;IACI,WAAW;IACX,eAAe;AACnB;;AAEA,kBAAkB;AAClB;;;;;;;;;GASG;;AAEH,mCAAmC;AACnC;;;;;;;;GAQG;;AAEH,0BAA0B;AAC1B;IACI,aAAa;IACb,oDAAoD;IACpD,SAAS;IACT,uBAAuB;IACvB,aAAa;;IAEb,4BAA4B;IAC5B,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA,4BAA4B;AAC5B;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,8BAA8B;IAC9B,WAAW;IACX,4BAA4B;AAChC;;AAEA,0BAA0B;AAC1B;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;;IAEhB,8BAA8B;IAC9B,mCAAmC;IACnC,wCAAwC;IACxC,0CAA0C;IAC1C;yFACqF;AACzF;;AAEA,kBAAkB;AAClB;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,kCAAkC;IAClC;yFACqF;AACzF;;AAEA;IACI,WAAW;IACX,aAAa;IACb,6BAA6B;IAC7B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;IAC5B,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA,iBAAiB;AACjB;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA,cAAc;AACd;IACI,eAAe;IACf,2BAA2B;IAC3B,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA,+BAA+B;AAC/B;IACI,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA,gBAAgB;AAChB;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA,sBAAsB;AACtB;IACI,2BAA2B;AAC/B;;AAEA,2BAA2B;AAC3B;IACI;QACI,oDAAoD;IACxD;AACJ;;AAEA;IACI;QACI,oDAAoD;IACxD;AACJ","sourcesContent":["/* Videos Page - Main Structure */\n.videos-page {\n    width: 100%;\n    margin: auto;\n    padding: 2rem;\n    background-color: var(--clr-background);\n    color: var(--clr-grey-1);\n\n    /* Border & Box Shadow for Professional Look */\n    border: 15px solid var(--clr-primary-5);\n    border-radius: var(--radius); \n    box-shadow: var(--shadow-2);\n    background: linear-gradient(\n        135deg, \n        var(--clr-primary-9) 0%, \n        var(--clr-primary-4) 100%\n    );\n\n    /* Subtle Inner Shadow for Depth */\n    box-shadow: inset 0px 4px 8px rgba(0, 0, 0, 0.05);\n}\n\n/* Header Section */\n.videos-header {\n    text-align: center;\n    margin-bottom: 2rem;\n}\n\n.videos-header h1 {\n    font-size: 2.5rem;\n    font-weight: bold;\n    color: var(--clr-grey-1);\n    text-transform: uppercase;\n    letter-spacing: 1px;\n\n    /* Fancy Text Gradient Effect */\n    background: linear-gradient(to right, var(--clr-primary-5), var(--clr-primary-3));\n    background-clip: text;\n    -webkit-background-clip: text;\n    /* -webkit-text-fill-color: transparent; */\n}\n\n\n.videos-header p {\n    font-size: 1.2rem;\n    color: var(--clr-grey-2);\n    /* max-width: 700px; */\n    margin: auto;\n}\n\n/* ✨ Stylish Divider */\n.divider {\n    width: 70%;\n    margin: 2rem auto;\n    border: none;\n    height: 4px;\n    background: linear-gradient(\n        to right,\n        transparent,\n        var(--clr-primary-5),\n        var(--clr-primary-6),\n        var(--clr-primary-5),\n        transparent\n    );\n    border-radius: var(--radius);\n    opacity: 0.8;\n    position: relative;\n}\n\n/* Adding subtle glowing effect */\n.divider::before,\n.divider::after {\n    content: \"\";\n    position: absolute;\n    width: 12px;\n    height: 12px;\n    background: var(--clr-primary-5);\n    border-radius: 50%;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n.divider::before {\n    left: 0;\n    box-shadow: 0 0 8px var(--clr-primary-5);\n}\n\n.divider::after {\n    right: 0;\n    box-shadow: 0 0 8px var(--clr-primary-6);\n}\n\n/* Main Video Section */\n.main-video-container {\n    text-align: center;\n    margin-bottom: 3rem;\n}\n\n.main-video-container h2 {\n    font-size: 1.8rem;\n    color: var(--clr-primary-2);\n    margin-bottom: 1rem;\n}\n\n/* Subtitle Effect */\n.video-description {\n    font-size: 1.1rem;\n    color: var(--clr-grey-2);\n    margin-top: 1rem;\n    font-style: italic;\n}\n\n/* Laptop Frame Styling */\n.laptop-frame {\n    width: 100%;\n    max-width: 800px;\n    margin: auto;\n    padding: 1.5rem;\n    background: var(--clr-white);\n    border: 6px solid var(--clr-grey-3);\n    border-radius: 20px; \n    box-shadow: var(--shadow-3); \n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    /* Shadow Effect */\n    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);\n}\n\n/* Video Styling */\nvideo {\n    width: 100%;\n    border-radius: 10px;\n    box-shadow: var(--shadow-2);\n    transition: transform 0.3s ease-in-out;\n}\n\n/* Hover Effect */\nvideo:hover {\n    transform: scale(1.02);\n}\n\n/* Sections & Video Cards */\n.video-sections {\n    width: 100%;\n    padding: 3rem 0;\n}\n\n/* Section Title */\n/* .section-title {\n    font-size: 1.8rem;\n    font-weight: 600;\n    color: var(--clr-grey-1);\n    text-align: center;\n    margin-bottom: 1.5rem;\n    position: relative;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n} */\n\n/* Section Title Underline Effect */\n/* .section-title::after {\n    content: \"\";\n    display: block;\n    width: 60px;\n    height: 3px;\n    background: var(--clr-grey-4);\n    margin: 0.5rem auto;\n    border-radius: 5px;\n} */\n\n/* Video Thumbnails Grid */\n.video-thumbnails {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(250px, 1fr));\n    gap: 60px;\n    justify-content: center;\n    padding: 1rem;\n\n    /* Spacing on Left & Right */\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 85%; \n}\n\n/* Subtle Background Panel */\n.video-thumbnails::before {\n    content: \"\";\n    position: absolute;\n    inset: 0; \n    background: var(--clr-grey-10);\n    z-index: -1;\n    border-radius: var(--radius);\n}\n\n/* Individual Video Card */\n.video-card {\n    background: var(--clr-white);\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-2);\n    transition: var(--transition);\n    overflow: hidden;\n    text-align: center;\n    padding: 1rem;\n    cursor: pointer;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    max-width: 320px;\n\n    /*  Professional Dual Border */\n    border: 3px solid var(--clr-grey-6);\n    background-clip: padding-box, border-box;\n    background-origin: padding-box, border-box;\n    background-image: linear-gradient(var(--clr-white), var(--clr-white)), \n                      linear-gradient(135deg, var(--clr-primary-5), var(--clr-primary-3));\n}\n\n/*  Hover Effect */\n.video-card:hover {\n    transform: translateY(-5px);\n    box-shadow: var(--shadow-3);\n    border-color: var(--clr-primary-6);\n    background-image: linear-gradient(var(--clr-white), var(--clr-white)), \n                      linear-gradient(135deg, var(--clr-primary-6), var(--clr-primary-4));\n}\n\n.video-thumbnail {\n    width: 100%;\n    height: 150px;\n    background: var(--clr-grey-9);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: var(--radius);\n    position: relative;\n    transition: var(--transition);\n    overflow: hidden; \n}\n\n.video-thumbnail img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover; \n    border-radius: var(--radius);\n    transition: var(--transition);\n}\n\n/* Hover Effect */\n.video-card:hover .video-thumbnail img {\n    filter: brightness(0.7);\n    transform: scale(1.05);\n}\n\n/* Play Icon */\n.play-icon {\n    font-size: 2rem;\n    color: var(--clr-primary-6);\n    position: absolute;\n    transition: var(--transition);\n}\n\n/* Hover Effect for Play Icon */\n.video-card:hover .play-icon {\n    color: var(--clr-primary-3);\n    transform: scale(1.1);\n}\n\n/* Video Title */\n.video-title {\n    font-size: 1rem; \n    font-weight: 600;\n    color: var(--clr-grey-2);\n    margin-top: 0.5rem;\n    transition: var(--transition);\n    text-align: center;\n}\n\n/* Video Title Hover */\n.video-card:hover .video-title {\n    color: var(--clr-primary-4);\n}\n\n/* Responsive Adjustments */\n@media (max-width: 1024px) {\n    .video-thumbnails {\n        grid-template-columns: repeat(2, minmax(200px, 1fr));\n    }\n}\n\n@media (max-width: 600px) {\n    .video-thumbnails {\n        grid-template-columns: repeat(1, minmax(200px, 1fr)); \n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
